import React, { useState, useCallback } from 'react';

export const PriceContext = React.createContext();

const toFixedNumber = (toFixTo = 2, base = 10) => num => {
  const pow = Math.pow(base, toFixTo);
  return +(Math.round(num * pow) / pow);
};

export const PriceProvider = ({ children }) => {
  const [price, setPrice] = useState({
    actual: 0,
    regular: 0,
    omnibus: 0,
  });

  const setPriceValues = useCallback(calculatedPrice => {
    const prices = calculatedPrice.overall;
    setPrice({
      actual: toFixedNumber(2)(prices.actual),
      regular: toFixedNumber(2)(prices.regular),
      omnibus: toFixedNumber(2)(prices.omnibus),
      ...calculatedPrice,
    });
  }, []);

  return (
    <PriceContext.Provider value={{ price, setPrice: setPriceValues }}>
      {children}
    </PriceContext.Provider>
  );
};
